import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LeadType,
  LeadTypeTranslation
} from '@shared/interfaces/setting.interface';

@Component({
    selector: 'app-lead-gen-card',
    templateUrl: './lead-gen-card.component.html',
    standalone: false
})
export class LeadGenCardComponent {
  // Data inputs
  @Input() logoUrl: string;
  @Input() logoAlt: string;
  @Input() leadTypes: LeadType[] = [];
  @Input() description: string;

  // State inputs
  @Input() isSubmitted = false;
  @Input() selectedLeadType: string;
  @Input() email: string;
  @Input() isSubmitting = false;
  @Input() mode: 'form' | 'none' = 'form';

  // Text inputs (translated by parent)
  @Input() titleText: string;
  @Input() subtitleText: string;
  @Input() emailLabel: string;
  @Input() emailHelp: string;
  @Input() contactButtonText: string;
  @Input() noThanksText: string;
  @Input() noDescriptionText: string;
  @Input() resetButtonText: string;
  @Input() fixedThankYouText: string;
  @Input() defaultButtonText: string;

  // Language
  @Input() language = 'en';

  // Display flags
  @Input() showNoDescription = false;
  @Input() showResetButton = false;
  @Input() skipEmailValidation = false;

  // Outputs
  @Output() leadTypeChange = new EventEmitter<string>();
  @Output() emailChange = new EventEmitter<string>();
  @Output() submitForm = new EventEmitter<void>();
  @Output() noThanks = new EventEmitter<void>();
  @Output() resetPreview = new EventEmitter<void>();

  emailTouched = false;

  get selectedLeadTypeObj(): LeadType | undefined {
    return this.leadTypes.find(
      (lt) => (lt.contact_type || lt.id) === this.selectedLeadType
    );
  }

  get absoluteDescription(): string {
    if (!this.description) {
      return this.description;
    }
    return this.description.replace(
      /href="([^"]+)"/gi,
      (_, url) => `href="${this.absoluteUrl(url)}"`
    );
  }

  get isValidEmail(): boolean {
    if (!this.email) {
      return false;
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
  }

  getLeadTypeField(
    leadType: LeadType,
    field: keyof LeadTypeTranslation
  ): string {
    return (
      leadType.translations?.[this.language]?.[field] ||
      (leadType as any)[field] ||
      ''
    );
  }

  onLeadTypeSelect(leadType: LeadType) {
    this.leadTypeChange.emit(leadType.contact_type || leadType.id);
  }

  onEmailInput(event: Event) {
    this.emailTouched = true;
    this.emailChange.emit((event.target as HTMLInputElement).value);
  }

  absoluteUrl(url: string): string {
    if (!url) {
      return url;
    }
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  }
}
